import { defineStore } from "pinia";

export const useMatchDetailStore = defineStore({
  id: "match_detail",

  state: () => {
    return {
      screenWidth: <number>400,
      screenHeight: <number>657,
      screenHeightVisualViewport: <number>window.innerHeight,
      heightPlayer: <number>250,
      playActiveTab: <string>'player',
      isShowChat: <boolean>true,
      isChatTyping: <boolean>false,
      activeTab: <string>'chat',
    };
  },

  getters: {
    getScreenWidth: (state): number => {
      return state.screenWidth;
    },
    getScreenHeight: (state): number => {
      return state.screenHeight;
    },
    getScreenHeightVisualViewport: (state): number => {
      return state.screenHeightVisualViewport;
    },
    getHeightPlayer: (state): number => {
      return state.heightPlayer;
    },
    getPlayActiveTab: (state): string => {
      return state.playActiveTab;
    },
    getHeightContent: (state): number => {
      if(!state.isShowChat && state.activeTab === "chat") {
        return 35;
      } else if(state.isChatTyping && state.activeTab !== "") {
        // @ts-ignore
        const screenHeight = state.playActiveTab === 'player' ? window.visualViewport.height : window.innerHeight;

        // 45: height tab
        // 10: khoảng cách các phần tử
        return screenHeight - state.heightPlayer - 45 - 10;
      }
      return state.screenHeight - 62;
    },
    getIsHideContent: (state): boolean => {
      return !state.isShowChat && state.activeTab === "chat";
    },
    getActiveTab: (state): string => {
      return state.activeTab;
    },
    getIsShowChat: (state): boolean => {
      return state.isShowChat;
    },
    getIsChatTyping: (state): boolean => {
      return state.isChatTyping;
    },
  },

  actions: {
    async setScreenWidth(value: number) {
      this.screenWidth = value;
    },
    async setScreenHeight(value: number) {
      this.screenHeight = value;
    },
    async setScreenHeightVisualViewport(value: number) {
      this.screenHeightVisualViewport = value;
    },
    async setHeightPlayer(value: number) {
      this.heightPlayer = value;
    },
    async setPlayActiveTab(value: string) {
      this.playActiveTab = value;
    },
    async setActiveTab(value: string) {
      this.activeTab = value;
    },
    async setIsShowChat(value: boolean) {
      this.isShowChat = value;
    },
    async setIsChatTyping(value: boolean) {
      this.isChatTyping = value;
    },
  },
});
